(() => {
  const menus = [...document.querySelectorAll('[data-emg-menu]')];

  const closeAll = (except) => {
    menus.forEach((menu) => {
      if (menu === except) return;
      const trigger = menu.querySelector('.emg-nav__trigger');
      const panel = menu.querySelector('.emg-mega');
      trigger?.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  };

  menus.forEach((menu) => {
    const trigger = menu.querySelector('.emg-nav__trigger');
    const panel = menu.querySelector('.emg-mega');
    if (!trigger || !panel) return;

    const open = () => {
      closeAll(menu);
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    };
    const close = () => {
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    };

    trigger.addEventListener('click', () => {
      trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });
    menu.addEventListener('mouseenter', open);
    panel.addEventListener('mouseenter', open);
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-emg-menu]')) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  const mobileGroups = [...document.querySelectorAll('[data-emg-mobile-group]')];
  mobileGroups.forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      mobileGroups.forEach((otherGroup) => {
        if (otherGroup !== group) otherGroup.open = false;
      });
    });
  });

  document.querySelectorAll('[data-emg-auto-carousel]').forEach((carousel) => {
    const slides = [...carousel.children];
    if (slides.length < 2) return;

    let activeIndex = 0;
    let isPaused = false;
    const moveToNext = () => {
      if (isPaused || window.innerWidth > 749 || document.hidden) return;
      activeIndex = (activeIndex + 1) % slides.length;
      carousel.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
    };
    const timer = window.setInterval(moveToNext, 2000);

    carousel.addEventListener('pointerdown', () => { isPaused = true; });
    carousel.addEventListener('pointerup', () => {
      window.setTimeout(() => { isPaused = false; }, 1800);
    });
    carousel.addEventListener('mouseenter', () => { isPaused = true; });
    carousel.addEventListener('mouseleave', () => { isPaused = false; });
    window.addEventListener('pagehide', () => window.clearInterval(timer), { once: true });
  });

  document.querySelectorAll('[data-emg-manual-carousel]').forEach((carousel) => {
    const slides = [...carousel.children];
    if (slides.length < 2 || carousel.nextElementSibling?.classList.contains('emg-carousel-controls')) return;

    let activeIndex = 0;
    let scrollFrame;
    const controls = document.createElement('div');
    const previousButton = document.createElement('button');
    const nextButton = document.createElement('button');
    const status = document.createElement('span');
    const hint = document.createElement('span');

    controls.className = 'emg-carousel-controls';
    previousButton.className = 'emg-carousel-control';
    nextButton.className = 'emg-carousel-control';
    status.className = 'emg-carousel-status';
    hint.className = 'emg-carousel-hint';
    previousButton.type = 'button';
    nextButton.type = 'button';
    previousButton.innerHTML = '<svg viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="M18.5 4.5 9 14l9.5 9.5"/></svg>';
    nextButton.innerHTML = '<svg viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="m9.5 4.5 9.5 9.5-9.5 9.5"/></svg>';
    previousButton.setAttribute('aria-label', 'Go back');
    nextButton.setAttribute('aria-label', 'Go forward');
    status.setAttribute('aria-live', 'polite');
    hint.innerHTML = '<span class="emg-carousel-hint__track" aria-hidden="true"><i></i></span><span>Swipe or use arrows</span>';

    controls.append(hint, previousButton, status, nextButton);
    carousel.insertAdjacentElement('afterend', controls);
    carousel.setAttribute('tabindex', '0');

    const updateControls = () => {
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === slides.length - 1;
      status.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    const moveTo = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      carousel.scrollTo({
        left: slides[activeIndex].offsetLeft - carousel.offsetLeft,
        behavior: 'smooth'
      });
      updateControls();
    };

    const syncActiveSlide = () => {
      const target = carousel.scrollLeft;
      activeIndex = slides.reduce((closestIndex, slide, index) => {
        const currentDistance = Math.abs(slides[closestIndex].offsetLeft - carousel.offsetLeft - target);
        const nextDistance = Math.abs(slide.offsetLeft - carousel.offsetLeft - target);
        return nextDistance < currentDistance ? index : closestIndex;
      }, 0);
      updateControls();
    };

    previousButton.addEventListener('click', () => moveTo(activeIndex - 1));
    nextButton.addEventListener('click', () => moveTo(activeIndex + 1));
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveTo(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveTo(activeIndex + 1);
      }
    });
    carousel.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(syncActiveSlide);
    }, { passive: true });

    updateControls();
  });
})();
